module.exports = __webpack_public_path__ + "img/P150T_weapon_20.190d309a.png";